import BaseCollection from '../../../lib/data/Collections/BaseCollection'
import SocketCommand from '@/api/SocketCommand'
import SupportStatusModel from '@/api/Models/support-center/SupportStatusModel'

export default class SupportStatusesCollection extends BaseCollection {
  constructor(items = []) {
    super(items, SupportStatusModel)

    this.fetchCommand = SocketCommand.SupportCenter.Ticket.Lists
  }

  /* PROPERTIES */

  /* METHODS */

  /* API METHODS */

  onFetch(data) {
    if (data.status) {
      super.onFetch(data.data.statuses)
      if (data.data.hasOwnProperty('services')) window.Vue.$DataStore.support.departments.clear().add(data.data.departments)
      if (data.data.hasOwnProperty('priorities')) window.Vue.$DataStore.support.priorities.clear().add(data.data.priorities)
      if (data.data.hasOwnProperty('priorities')) window.Vue.$DataStore.support.services.clear().add(data.data.services)
    }
  }
}
